import type { Site } from '../Site';

export const ITProPortal: Site = {
  id: 'itproportal',
  analyticsName: 'itproportal',
  selector: '',
  logo: '',
  label: 'IT Pro Portal',
  platform: '',
};
